export default {
  groupName: 'ford-us',
  appName: 'Ford US',
  isAuto: true,
  baseRoute: '/ford-us',
  image: 'ford.png',
  description:
    'Ford - US Non-Luxury Tier 1/1.5 Advertising Dashboard (Starting Jan 2019)'
}
